<template>
  <Card>
    <Row>
      <ECharts :options="options" @legendselectchanged="something" />
    </Row>
    <Row>
      <input type="radio" v-model="isCumulative" :value="true" /> Cumnulative Figures &nbsp;
      <input type="radio" v-model="isCumulative" :value="false" /> Monthly Figures
    </Row>
  </Card>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import ECharts from "vue-echarts";
import "echarts/lib/chart/line";
import "echarts/lib/chart/bar";
import "echarts/lib/component/title";
import "echarts/lib/component/legend";
import "echarts/lib/component/markPoint";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/dataZoom";
import "echarts/lib/component/polar";

export default {
  // Initialization
  // -------------------------------------------------------------------
  name: "MonthlyFiguresDisastersChart",
  components: { ECharts },

  // State
  // -------------------------------------------------------------------
  data() {
    return {
      isCumulative: true,
      options: {
        animationDuration: 500,
        title: { text: "Disasters monthly figures" },
        legend: {},
        grid: {
          // left: "8%",
          // right: "0.5%",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
          },
        },
        toolbox: {
          show: true,
          feature: {
            dataZoom: { yAxisIndex: "none", title: "Zoom" },
            restore: { title: "Restore" },
            saveAsImage: { title: "Save as image" },
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
          ],
          legend: {},
        },
        yAxis: {},
        series: [],
        dataZoom: [
          { type: "inside", start: 0, end: 100 },
          { type: "slider", start: 0, end: 100 },
        ],
      },
    };
  },

  // Life Cycle
  // -------------------------------------------------------------------
  created() {
    this.load();
  },

  // watcher
  // -------------------------------------------------------------------
  watch: {
    isCumulative() {
      this.updateChart();
    },
  },

  // Methods
  // -------------------------------------------------------------------
  methods: {
    // Load dataset
    async load() {
      const url = "/psql/qa_dashboard_monthly_figures_disasters";
      let response = await axios.get(url);
      // this.dataset = response.data;
      this.dataset = response.data;
      this.updateChart();
    },

    updateChart() {
      const data = this.dataset;
      let years = data.map(i => i.year);
      years = Set.from(years);
      years = Array.from(years);
      years.sort();

      const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      const categories = [{ category: months.map(m => ({ label: m })) }];

      const dataByYear = {};
      for (const row of data) {
        const values = dataByYear[row.year] || [];
        if (this.isCumulative) {
          values.push(row.cumulative_figure);
        } else {
          values.push(row.figure);
        }
        dataByYear[row.year] = values;
      }
      // console.log(dataByYear);

      const currentYear = new Date().getYear() + 1900;
      const series = [];
      for (const key in dataByYear) {
        if (dataByYear.hasOwnProperty(key)) {
          const year = parseInt(key, 10);
          series.push({
            name: `${year}`,
            type: "line",
            data: dataByYear[year],
            lineStyle: {
              // color: year === currentYear ? "#ee8f49" : undefined,
              // width: year === currentYear ? 3 : 2,
              opacity: year === currentYear ? 1.0 : 0.3,
              type: year === currentYear ? "solid" : "dotted",
            },
          });
        }
      }

      const firstYear = years[0];
      const lastYear = years[years.length - 1];
      this.options.series = series;
    },
    something(params) {
      // find the last year in the series
      const selected = params.selected;
      const labels = Object.keys(selected).sort((a, b) => b - a);
      let lastYear = ``;
      for (const label of labels) {
        if (selected[label]) {
          lastYear = label;
          break;
        }
      }
      // update the properties of the series
      this.options.series = this.options.series.map(series => {
        return {
          ...series,
          lineStyle: {
            // width: series.name === lastYear ? 3 : 2,
            opacity: series.name === lastYear ? 1.0 : 0.3,
            type: series.name === lastYear ? "solid" : "dotted",
          },
        };
      });
    },
  },
};
</script>

<style>
.echarts {
  width: 100%;
  height: 600px;
}
</style>
